// src/components/FractionalizationPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useAppContext } from "../context/AppContext";

const FractionalizationPage = () => {
  const navigate = useNavigate();
//   const { setAppState } = useAppContext();

  const [platform, setPlatform] = useState("Fractional.art");
  const [tokenName, setTokenName] = useState("");
  const [tokenSymbol, setTokenSymbol] = useState("");

  const handleNext = () => {
    if (!tokenName || !tokenSymbol) {
      alert("Please complete all fields.");
      return;
    }
    // setAppState((prev) => ({
    //   ...prev,
    //   fractionalizationDetails: { platform, tokenName, tokenSymbol },
    // }));
    console.log("{ platform, tokenName, tokenSymbol }", { platform, tokenName, tokenSymbol });
    
    navigate("/fundraising-goal");
  };

  return (
    <div className="fractionalization-page">
      <h2>Fractionalize Your NFT</h2>
      <select onChange={(e) => setPlatform(e.target.value)} value={platform}>
        <option value="Fractional.art">Fractional.art</option>
        <option value="Unicly">Unicly</option>
      </select>
      <input
        type="text"
        placeholder="Token Name"
        value={tokenName}
        onChange={(e) => setTokenName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Token Symbol"
        value={tokenSymbol}
        onChange={(e) => setTokenSymbol(e.target.value)}
      />
      <button onClick={handleNext}>Next Step</button>
    </div>
  );
};

export default FractionalizationPage;
